<template>
  <b-container>
    <div v-if="buildings.length > 0">
      <b-row class="mt-2">
        <b-col sm="4" class="mt-4">
          <b-form-select v-model="building" :options="buildings" v-on:change="OnBuildingClick"></b-form-select>
        </b-col>
      </b-row>
    </div>

    <div v-if="building">
      <b-row>
        <b-col sm="4" class="mt-4">
          <div>
            <strong>Source</strong>
          </div>
          <b-form-select v-model="source" :options="sourceList" v-on:change="OnSourceClick"></b-form-select>
          <div class="text-danger" v-if="!$v.source.required && $v.source.$dirty">
            {{ $t("info.required") }}
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-if="source">
      <div v-if="client && client.Status === 'inactive'">
        <b-alert show variant="info" class="mt-4">
          <p>{{ $t('info.inactiveKey') }}</p>
        </b-alert>
      </div>
      <div v-else>
        <div sm="6" class="mt-4">
          <strong>{{ $t("label.fieldList") }}</strong>
        </div>
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group id="formFieldCheckboxGroup" v-model="fields" :aria-describedby="ariaDescribedby"
            name="fields" stacked>
            <b-form-checkbox value="phone">phone</b-form-checkbox>
            <b-form-checkbox value="budget">budget</b-form-checkbox>
            <b-form-checkbox value="howDidYouHear">howDidYouHear</b-form-checkbox>
            <b-form-checkbox value="bedrooms">bedrooms</b-form-checkbox>
            <b-form-checkbox value="optin">optin</b-form-checkbox>
            <b-form-checkbox value="currentPlace">currentPlace</b-form-checkbox>
            <b-form-checkbox value="language">language</b-form-checkbox>
            <b-form-checkbox value="others">others</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

        <b-button v-if="client" class="mt-4" variant="outline-success" @click="addUpdateClient('updateClient')">{{
          $t("action.update")
        }}</b-button>

        <b-button v-else class="mt-4" variant="outline-success" @click="addUpdateClient('addClient')">{{
          $t("action.submit")
        }}</b-button>
        <b-row v-if="client" ref="client">
          <b-col class="mt-4">
            <b-alert show variant="dark">
              <b-button variant="link" @click="copyTextToClipboard()">{{ $t("action.copy") }}</b-button>
              <div class="mt-2">
                <strong>Endpoint</strong> : {{ client.Endpoint }}
              </div>
              <div><strong>method</strong> : POST</div>
              <div><strong>content-type</strong> : application/json</div>
              <div class="mt-4">
                <strong>Object</strong> :
                <div>{</div>
                <div class="ml-4">
                  <div>"TOKEN" : "{{ client.Token }}",</div>
                  <div>"NOCIE" : {{ client.NOCIE }},</div>
                  <div>"NODIV" : {{ client.NODIV }},</div>
                  <div>"name" : "",</div>
                  <div>"email" : "",</div>
                  <div v-if="client.Fields.length > 0">
                    <div v-for="(field, index) in client.Fields" :key="'field-' + index">
                      "{{ field.trim() }}" : "",
                    </div>
                  </div>
                  <div v-if="client.OtherFieldsArr && client.OtherFieldsArr.length > 0">
                    <div v-for="(field, index) in client.OtherFieldsArr" :key="'OtherFields-' + index">
                      "{{ field.trim() }}" : "",
                    </div>
                  </div>
                  <div>"message" : ""</div>
                </div>
                <div>}</div>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </div>

    </div>

    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import { globalF } from "../../Helpers";
import { required } from 'vuelidate/lib/validators';

export default {
  mixins: [globalF],
  data() {
    return {
      error: "",
      allBuilding: [],
      buildings: [],
      client: null,
      building: null,
      spinner: false,
      source: null,
      fields: [],
      sourceList: []
    };
  },
  validations() {
      return {
        source: {
          required
        }
      }
  },
  mounted() {
    this.ajaxCall();
  },
  computed: {},
  methods: {
    ajaxCall() {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      let promise = this.validateToken();
      promise.then(() => {
        axios
          .post(
            url,
            { request: "getMultiKeyRessource" },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            this.spinner = false;
            this.buildings = this.mapBuildingForSelect(response.data.buildings);
            this.sourceList = this.setSourceList(response.data.source);
            this.allBuilding = response.data.buildings;
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      });
    },
    setSourceList(sourceList) {
      let sourceListSelectList = sourceList.map(s => {
        return {
          value: s.SourceName, 
          text: s.SourceName
        }
      })

      sourceListSelectList.sort(function (a, b) {
        if (a.text < b.text) { return -1; }
        if (a.text > b.text) { return 1; }
        return 0;
      });

      sourceListSelectList.unshift({
        text: "Source",
        value: null
      });

      return sourceListSelectList;
    },
    OnBuildingClick() {
      this.fields = [];
      this.client = null;
      this.source = null;
    },
    OnSourceClick() {
      if (this.source) {
        this.fields = [];
        this.client = null;
        this.getClient();
      }
    },
    getClient() {
      this.spinner = true;
      this.error = "";
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      let promise = this.validateToken();
      promise.then(() => {
        axios
          .post(
            url,
            { request: "getClient", building: this.building, source: this.source },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((response) => {
            this.spinner = false;
            if (response.data) {
              this.mapData(response.data);
              this.client = response.data;
              if (this.client.Fields.length > 0) {
                this.client.Fields = this.client.Fields.filter((field) => {
                  return field.trim() !== "others";
                });
              }
              if (this.client.OtherFields) {
                this.client.OtherFieldsArr = this.client.OtherFields.split(",");
              }
            }
          })
          .catch(() => {
            this.spinner = false;
            this.error = this.$t("info.errorgeneric");
          });
      });
    },
    mapData(client) {
      let fields = client.Fields;
      this.fields = fields.map((field) => {
        return field.trim();
      });
    },
    copyTextToClipboard() {
      let client = this.$refs.client;
      let range = document.createRange();
      range.selectNode(client);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
    },
    addUpdateClient(request) {
      this.$v.$touch();
      this.error = "";
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      if (!this.$v.$invalid) {
        this.spinner = true;
        let obj = {
          request: request,
          NOCIE: this.building.NOCIE,
          NODIV: this.building.NODIV,
          NOMDIV: this.building.NOMDIV,
          source: this.source,
          fields: this.fields,
          client: this.client
        };

        let promise = this.validateToken();
        promise.then(() => {
          axios
            .post(url, obj, { headers: { "Content-Type": "application/json" } })
            .then((response) => {
              this.spinner = false;
              if (response.data) {
                this.mapData(response.data);
                this.client = response.data;
                if (this.client.Fields.length > 0) {
                  this.client.Fields = this.client.Fields.filter((field) => {
                    return field.trim() !== "others";
                  });
                }
                if (this.client.OtherFields) {
                  this.client.OtherFieldsArr = this.client.OtherFields.split(",");
                }
              }
            })
            .catch(() => {
              this.spinner = false;
              this.error = this.$t("info.errorgeneric");
            });
        });
      }
    },
  },
};
</script>
